import {Autor} from '../autor/autor'

export class Trabalho {
    id: number;
    titulo: string;
    resumo: string;
    inscricao_id: number;
    evento_id: number;
    modalidade_id: number;
    categoria_cientifica_id: number;
	orcamento: string;
    created_at: string;
    updated_at: string;
    autores: Autor[];
    tipo: string;
    evento_name: string;
    parecer: File;
    usuario_id: number;
    usuario_name: string;
    send_status: string;
    parecerista_id: number;
	grupo: number;
    enviado:boolean;
	nome_financeiro: string;
	tel_financeiro: string;
	email_financeiro: string;
	unidade_executora: string;
	nome_local: string;
	tel_local: string;
	diretor_local: string;
	email_local: string;
	datas_ini: any[];
	datas_fim: any[];
	nota: number;
	orcamento_utilizado: any;
	data_certificado: Date;
	carga_horaria: number;
	inicio_evento: any;
	fim_evento: any;
}



// WEBPACK FOOTER //
// ./src/app/trabalho/trabalho.ts